import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChevronDown } from "lucide-react";

export default function FaqSection() {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await api.get("/business");
        if (mounted) {
          setFaqs(res.data?.faqs || []);
        }
      } catch (e) {
        console.error("Failed to load FAQs:", e);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section
      className="section-padding border-b border-white/10 rz-section"
      data-testid="faq-section"
    >
      <div className="container-main">
        <div className="grid gap-6 lg:grid-cols-[0.48fr_1fr]">
          <div className="border border-white/10 bg-white/[0.025] p-6 lg:p-8">
            <p className="mb-4 text-[11px] uppercase tracking-[0.24em] text-[var(--text-muted)]">
              FAQ
            </p>

            <h3 className="text-3xl lg:text-4xl leading-none text-[var(--text-primary)]">
              Întrebări frecvente despre cum funcționează Rezervix
            </h3>

            <p className="mt-6 max-w-md leading-8 text-[var(--text-muted)]">
            Aici găsești răspunsuri la cele mai frecvente întrebări despre cum funcționează platforma și cum te ajută să obții cereri de rezervare direct de la oaspeți.
            </p>

            <div className="mt-10 border-t border-white/10 pt-6">
              <span className="headline-outline text-7xl leading-none opacity-20">
                {faqs.length}
              </span>
              <p className="mt-3 text-sm uppercase tracking-[0.18em] text-[var(--text-muted)]">
                întrebări disponibile
              </p>
            </div>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;

              return (
                <div
                  key={faq.id || index}
                  className={`group overflow-hidden border transition-all duration-300 ${
                    isOpen
                      ? "border-white/20 bg-white/[0.05]"
                      : "border-white/10 bg-white/[0.025] hover:border-white/16 hover:bg-white/[0.035]"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-start justify-between gap-5 px-5 py-5 text-left lg:px-7 lg:py-6"
                  >
                    <div className="flex items-start gap-4 lg:gap-5">
                      <span
                        className={`headline-outline mt-0.5 text-3xl lg:text-4xl transition-opacity ${
                          isOpen ? "opacity-50" : "opacity-25 group-hover:opacity-40"
                        }`}
                      >
                        {String(index + 1).padStart(2, "0")}
                      </span>

                      <div>
                        <h3 className="text-2xl lg:text-3xl leading-[1.05] text-[var(--text-primary)]">
                          {faq.question || faq.title}
                        </h3>
                      </div>
                    </div>

                    <div
                      className={`mt-1 flex h-11 w-11 flex-shrink-0 items-center justify-center border border-white/10 bg-white/[0.03] transition-all duration-300 ${
                        isOpen ? "rotate-180 border-white/20 bg-white/[0.06]" : ""
                      }`}
                    >
                      <ChevronDown className="h-5 w-5 text-[var(--text-primary)]" />
                    </div>
                  </button>

                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="border-t border-white/10 px-5 pb-6 pt-5 lg:px-7 lg:pb-7">
                        <p className="max-w-3xl leading-8 text-[var(--text-soft)]">
                          {faq.answer || faq.description || faq.answear}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}